import { Component, Input } from '@angular/core';
import { MaterialModule } from '@fullyops/shared/material.module';

@Component({
  selector: 'crm-expansion-panel',
  templateUrl: './expansion-panel.component.html',
  styleUrls: ['./expansion-panel.component.scss'],
  standalone: true,
  imports: [MaterialModule],
})
export class ExpansionPanelComponent {
  @Input() title: string = '';
  @Input() icon: string;
  @Input() tooltip: string;
  @Input() isExpanded: boolean = true;
}
